import React from 'react';
import { Theme, withStyles } from '@material-ui/core/styles';
import { Select } from 'react-design-components';

const StyledSelect = withStyles((theme: Theme) => ({
  root: {
    padding: '0 12px',
    height: 48,
    color: theme.palette.grey.A700,
    border: `1px solid ${theme.palette.grey.A200}`,
    fontSize: 18,
    [theme.breakpoints.down('xs')]: {
      padding: '0 6px',
      height: 42,
      fontSize: 14,
    },
  },
}))(Select);

interface Props {
  onChange: (e: any) => void;
  items: any;
  value: string | number;
  defaultValue?: string;
}

const SelectDropdown = ({ onChange, items, value, defaultValue }: Props): React.ReactElement<Props> => (
  <StyledSelect items={items} value={value} defaultValue={defaultValue} onChange={onChange} />
);

export default SelectDropdown as React.ComponentType<Props>;
